<button
  mat-raised-button color="primary"
  *ngFor="let control of controls"
  (click)="dial(control.url)">
  {{control.name}}
</button>
